import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

import { Button, Menu, MenuItem } from "@mui/material";

import TextFields from "@mui/icons-material/TextFields";
import Link from "@mui/icons-material/Link";
import PostAdd from "@mui/icons-material/PostAdd";

interface ChunkTypeMenuProps {
    chunkType: string;
    handleTypeChange: Function;
    showMenu: Boolean;
}

const ChunkTypeMenu = observer(
    ({ chunkType, handleTypeChange, showMenu }: ChunkTypeMenuProps) => {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const [cardType, setCardType] = React.useState(chunkType);

        const handleClick = (event: any) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = (cT: string) => {
            setCardType(cT);
            handleTypeChange(cT);
            setAnchorEl(null);
        };

        console.log(showMenu);
        if (showMenu !== undefined && !showMenu) {
            return (
                <div
                    style={{
                        position: "absolute",
                        left: "-50px",
                        padding: "0 10"
                    }}
                >
                    {cardType === "text" ||
                    cardType === undefined ||
                    cardType === "" ? (
                        <TextFields />
                    ) : (
                        <div />
                    )}
                    {cardType === "link" ? <Link /> : <div />}
                    {cardType === "card" ? <PostAdd /> : <div />}
                </div>
            );
        }
        console.log(cardType);

        return (
            <div>
                <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    style={{
                        position: "absolute",
                        left: "-50px",
                        padding: "0 10"
                    }}
                >
                    {cardType === "text" ||
                    cardType === undefined ||
                    cardType === "" ? (
                        <TextFields />
                    ) : (
                        <div />
                    )}
                    {cardType === "link" ? <Link /> : <div />}
                    {cardType === "card" ? <PostAdd /> : <div />}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => handleClose("text")}>
                        <TextFields />
                        &nbsp;Text
                    </MenuItem>
                    <MenuItem onClick={() => handleClose("link")}>
                        <Link />
                        &nbsp;Link
                    </MenuItem>
                    <MenuItem onClick={() => handleClose("card")}>
                        <PostAdd />
                        &nbsp;New Card
                    </MenuItem>
                </Menu>
            </div>
        );
    }
);

export default ChunkTypeMenu;
